module.exports = __webpack_public_path__ + "img/tutorial.082ed1fe.svg";